<template>
  <div class="categories">
    <mainmenu selected="categories"></mainmenu>

    <div class="admin-page-shell">
      <div class="admin-toolbar">
        <div>
          <h1>{{ $t("categories.page_title") }}</h1>
          <div class="toolbar-subtitle">
            {{ $t("categories.total_categories") }} <strong>{{ PaginationInfo.RowCount }}</strong>
          </div>
        </div>
        <el-button type="primary" icon="el-icon-plus" @click="add_item()">{{ $t("add_item") }}</el-button>
      </div>

      <div class="admin-filters categories-filters">
        <div class="filters-title">{{ $t("categories.filters") }}</div>
        <el-input
          class="filter-control filter-search"
          v-model="Filters.Search"
          :placeholder="$t('categories.search_placeholder')"
          prefix-icon="el-icon-search"
          clearable
          @input="on_filter_input"
          @clear="apply_filters">
        </el-input>
        <el-select
          class="filter-control"
          v-model="Filters.ApprovalStatus"
          :placeholder="$t('categories.approval_status')"
          clearable
          @change="apply_filters">
          <el-option :label="$t('categories.approved')" value="approved"></el-option>
          <el-option :label="$t('categories.pending')" value="pending"></el-option>
        </el-select>
        <el-button class="reset-filters" icon="el-icon-refresh-left" @click="reset_filters">{{ $t("reset") }}</el-button>
      </div>

      <div class="admin-card">
        <div class="admin-card-heading">
          <div>
            <h2>{{ $t("categories.list_title") }}</h2>
            <span>{{ $t("categories.sorted_by_newest") }}</span>
          </div>
          <el-tag size="small" type="info">{{ $t("categories.total") }} {{ PaginationInfo.RowCount }}</el-tag>
        </div>

        <el-table
          class="admin-table"
          :data="Results"
          style="width: 100%"
          :max-height="TableMaxHeight"
          stripe
          v-loading="tableLoadingVisible"
          :empty-text="$t('categories.empty_results')">
          <el-table-column :label="$t('categories.name')" min-width="280" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="primary-cell">
                <span>{{ scope.row.Name }}</span>
                <el-tag v-if="is_pending(scope.row)" size="mini" type="warning">{{ $t("categories.pending") }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('categories.old_product_price')" width="190" align="right" header-align="right">
            <template slot-scope="scope">
              <span class="numeric-cell">{{ format_price(scope.row.OldProductPrice) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('categories.proposed_by_user')" min-width="220" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.ProposedByUser || "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('categories.status')" width="135">
            <template slot-scope="scope">
              <el-tag v-if="is_pending(scope.row)" size="mini" type="warning">{{ $t("categories.pending") }}</el-tag>
              <el-tag v-else size="mini" type="success">{{ $t("categories.approved") }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column fixed="right" :label="$t('categories.operations')" width="210" align="right" header-align="right">
            <template slot-scope="scope">
              <div class="operation-actions">
                <el-button v-if="is_pending(scope.row)" @click="approve_item(scope.row)" type="text" size="mini" class="approve-action">{{ $t("categories.approve") }}</el-button>
                <el-button @click="edit_item(scope.row)" type="text" size="mini">{{ $t("edit") }}</el-button>
                <el-button @click="delete_item(scope.row)" type="text" size="mini" class="danger-action">{{ $t("delete") }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="admin-pagination">
          <el-pagination
            background
            @size-change="refresh_info"
            @current-change="refresh_info"
            :page-size.sync="PaginationInfo.PerPage"
            :current-page.sync="PaginationInfo.Page"
            :total="PaginationInfo.RowCount"
            layout="total, prev, pager, next">
          </el-pagination>
        </div>
      </div>
    </div>
    <category-dialog ref="item_dialog" @save="refresh_info" />
  </div>
</template>

<script>
import MainMenu from "./../widgets/MainMenu";
import settings from "./../backend/LocalSettings";
import CategoryDialog from "./../views/dialogs/CategoryDialog";

export default {
  name: "categories",
  components: {
    "mainmenu": MainMenu,
    "category-dialog": CategoryDialog
  },
  data () {
    return {
      tableLoadingVisible: false,
      Results: [],
      Filters: { Search: "", ApprovalStatus: "" },
      TableMaxHeight: 620,
      ResizeTimer: null,
      FilterTimer: null,
      RequestSerial: 0,
      PaginationInfo: { Page: 1, PerPage: 20, RowCount: 0, PageSizes: [20] }
    }
  },
  methods: {
    get_default_filters: function() {
      return { Search: "", ApprovalStatus: "" };
    },
    get_visible_page_size: function() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 900;
      var cardElement = this.$el ? this.$el.querySelector(".admin-card") : null;
      var cardTop = cardElement ? cardElement.getBoundingClientRect().top : 215;
      var paginationHeight = 52;
      var cardHeaderHeight = 64;
      var bottomPadding = 18;
      var availableTableHeight = Math.max(300, viewportHeight - cardTop - paginationHeight - cardHeaderHeight - bottomPadding);
      this.TableMaxHeight = availableTableHeight;

      var rowHeight = 43;
      var tableHeaderHeight = 48;
      var visibleRows = Math.floor((availableTableHeight - tableHeaderHeight) / rowHeight);
      return Math.max(8, Math.min(18, visibleRows));
    },
    fit_page_size_to_viewport: function() {
      var pageSize = this.get_visible_page_size();
      this.PaginationInfo.PageSizes = [pageSize];
      if( this.PaginationInfo.PerPage != pageSize )
      {
        this.PaginationInfo.PerPage = pageSize;
        return true;
      }
      return false;
    },
    on_window_resize: function() {
      clearTimeout(this.ResizeTimer);
      this.ResizeTimer = setTimeout(() => {
        if( this.fit_page_size_to_viewport() )
        {
          this.PaginationInfo.Page = 1;
          this.refresh_info();
        }
      }, 150);
    },
    apply_filters: function() {
      this.PaginationInfo.Page = 1;
      this.refresh_info();
    },
    on_filter_input: function() {
      clearTimeout(this.FilterTimer);
      this.FilterTimer = setTimeout(() => {
        this.apply_filters();
      }, 300);
    },
    reset_filters: function() {
      clearTimeout(this.FilterTimer);
      this.Filters = this.get_default_filters();
      this.apply_filters();
    },
    refresh_info: function() {
      this.fit_page_size_to_viewport();
      var requestSerial = ++this.RequestSerial;
      this.tableLoadingVisible = true;
      this.$http
        .post("categories/refresh_info", { Filters: this.Filters, PaginationInfo: this.PaginationInfo })
        .then((response) => {
          if(requestSerial !== this.RequestSerial) return;
          this.tableLoadingVisible = false;
          if( settings.verify_response(response, this.$rights)) {
            this.Results = response.body.Results;
            this.PaginationInfo = response.body.PaginationInfo;
          } else {
            this.$router.push("/");
          }
        })
        .catch(() => {
          if(requestSerial !== this.RequestSerial) return;
          this.tableLoadingVisible = false;
          this.$message.error(this.$t("categories.load_failed"));
        });
    },
    add_item: function(){
      this.$refs.item_dialog.show_me(null);
    },
    edit_item: function(item){
      this.$refs.item_dialog.show_me(item);
    },
    approve_item: function(item){
      this.$confirm(this.$t("categories.confirm_approve"), this.$t("warning_title"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning"
      }).then(() => {
        this.tableLoadingVisible = true;
        this.$http
          .post("categories/approve_item", { object: item })
          .then((response) => {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.refresh_info();
            } else {
              this.$router.push("/");
            }
          })
          .catch(() => {
            this.tableLoadingVisible = false;
            this.$message.error(this.$t("categories.approve_failed"));
          });
      }).catch(() => {} );
    },
    delete_item: function(item){
      this.$confirm(this.$t("confirm_delete"), this.$t("warning_title"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning"
      }).then(() => {
        this.tableLoadingVisible = true;
        this.$http
          .post("categories/delete_item", { object: item })
          .then((response) => {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.refresh_info();
            } else {
              this.$router.push("/");
            }
          })
          .catch(() => {
            this.tableLoadingVisible = false;
            this.$message.error(this.$t("categories.delete_failed"));
          });
      }).catch(()=>{ });
    },
    is_pending: function(item) {
      return String(item.Approved) === "0";
    },
    format_price: function(value) {
      var numberValue = Number(value);
      if(isNaN(numberValue)) return value || "-";
      return numberValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " EUR";
    }
  },
  mounted: function() {
    this.fit_page_size_to_viewport();
    window.addEventListener("resize", this.on_window_resize);
    this.refresh_info();
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.on_window_resize);
    clearTimeout(this.ResizeTimer);
    clearTimeout(this.FilterTimer);
  }
};
</script>

<style lang="less" scoped>
@import "../styles/admin-list.less";

.categories-filters {
  grid-template-columns: auto minmax(280px, 1fr) minmax(210px, 0.45fr) auto;
}
</style>
